import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eld88Config: TSPConfig = {
  key: 'eld88',
  name: 'ELD88',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API Key from ELD88 support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default eld88Config;
